import axios from 'shared/lib/axios';

import { DashboardWidgetConfig } from './types';

export const getDashboardWidgetConfigs = ({ tenancyId }: { tenancyId: number }) => {
  return axios.get<DashboardWidgetConfig[][]>(`/v2/tenancies/${tenancyId}/dashboard`).then(res => res.data);
};
